export interface RefreshJob {
  name: string;
  run: () => Promise<void>;
}

// Each job applies its own result immediately. Failed domains retain their cache.
export async function refreshIndependently(jobs: RefreshJob[]): Promise<string[]> {
  const results = await Promise.allSettled(jobs.map(async job => job.run()));
  return results.flatMap((result, index) => result.status === 'rejected' ? [jobs[index].name] : []);
}

export function refreshMessage(failures: string[]): string {
  return failures.length
    ? `Teilweise synchronisiert. Nicht aktualisiert: ${failures.join(', ')}. Vorhandene Offline-Daten bleiben verfügbar. Bitte erneut synchronisieren.`
    : 'Alles synchronisiert';
}
